import { useEffect, useState } from 'react';

import { EVENTS, TABS } from '../fitment-constants';

export default function useBrand({
  getTireBrands,
  getWheelBrands,
  queryErrorEvent,
  selectedBrandTab,
  selectedTab
}) {
  const [tireBrands, setTireBrands] = useState([]);
  const [wheelBrands, setWheelBrands] = useState([]);

  useEffect(() => {
    if (
      selectedTab !== TABS.BRAND ||
      !Array.isArray(tireBrands) ||
      !Array.isArray(wheelBrands)
    )
      return;
    if (selectedBrandTab === TABS.TIRES && !tireBrands.length) {
      getTireBrands()
        .then(setTireBrands)
        .catch(
          queryErrorEvent(EVENTS.ERROR_QUERY_GET_BRAND_CATEGORIES_BY_SEO_NAME)
        );
    } else if (selectedBrandTab === TABS.WHEELS && !wheelBrands.length) {
      getWheelBrands()
        .then(setWheelBrands)
        .catch(
          queryErrorEvent(EVENTS.ERROR_QUERY_GET_BRAND_CATEGORIES_BY_SEO_NAME)
        );
    }
  }, [
    selectedTab,
    selectedBrandTab,
    tireBrands,
    wheelBrands,
    getTireBrands,
    queryErrorEvent,
    getWheelBrands
  ]);

  return {
    tireBrands,
    wheelBrands
  };
}
